var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatrixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 4.5H4.25C3.85218 4.5 3.47064 4.65804 3.18934 4.93934C2.90804 5.22064 2.75 5.60218 2.75 6V18C2.75 18.3978 2.90804 18.7794 3.18934 19.0607C3.47064 19.342 3.85218 19.5 4.25 19.5H20.75C21.1478 19.5 21.5294 19.342 21.8107 19.0607C22.092 18.7794 22.25 18.3978 22.25 18V6C22.25 5.60218 22.092 5.22064 21.8107 4.93934C21.5294 4.65804 21.1478 4.5 20.75 4.5ZM10.25 13.5V10.5H14.75V13.5H10.25ZM14.75 15V18H10.25V15H14.75ZM4.25 10.5H8.75V13.5H4.25V10.5ZM10.25 9V6H14.75V9H10.25ZM16.25 10.5H20.75V13.5H16.25V10.5ZM20.75 9H16.25V6H20.75V9ZM8.75 6V9H4.25V6H8.75ZM4.25 15H8.75V18H4.25V15ZM20.75 18H16.25V15H20.75V18Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrixIcon);
export default __webpack_public_path__ + "static/media/MatrixIcon.2e2242c36886a4407994f24ce3043077.svg";
export { ForwardRef as ReactComponent };